import { ResponseRepresentationSmartAccountRepresentation } from "src/app/api/smart-pensjon-rest-api/models";

/** UNQUALIFIED keeps the dashboard Smartkonto link hidden offline, as today. */
export function generateMockSmartAccountStatus(): ResponseRepresentationSmartAccountRepresentation {
  return { payload: { state: "UNQUALIFIED" } };
}
